export default {
	readings: {
		general: {
			measure: "Measure",
			latest: "Latest",
			history_graph: "History graph",
			history_map: "History map",
			alert_parameters: "Alerts parameters",
			alert_reports: "Report of alerts",
			zone_list: "Zones list",
			no_readings: "No readings found",
			no_parameters: "No parameters found",
			no_zones: "No zones found",
			no_alerts: "No alerts found",
			no_location: "No location found",
		},
		hearthrate: {
			name: "Heart Rate",
			unit: "bpm",
			html: "bpm"
		},
		bloodpressure: {
			name: "Blood Pressure",
			unit: "mmHg",
			html: "mmHg"
		},
		temperature: {
			name: "Temperature",
			unit: "°C",
			html: "°C"
		},
		bloodsaturation: {
			name: "Blood Saturation",
			unit: "% spO2",
			html: "% spO<sub>2</sub>"
		},
		position: {
			name: "Position",
			unit: "lat lng",
			html: "lat lng"
		},
		calories: {
			name: "Calories",
			unit: "kcal",
			html: "kcal"
		},
		pedometer: {
			name: "Pedometer",
			unit: "steps",
			html: "steps"
		},
		falls: {
			name: "Falls",
			unit: "",
			html: "",
			fall_detected: "Fall detected"
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/readings/readings_en-gb.js